import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import styled from 'styled-components';
import { FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab, faHtml5, faCss3Alt, faJs, faReact, faGithubSquare, faYoutube} from '@fortawesome/free-brands-svg-icons'
import {faCube, faLink} from '@fortawesome/free-solid-svg-icons'
import { dom } from '@fortawesome/fontawesome-svg-core'
dom.watch()

{/* <i class="fas fa-link"></i> */}
{/* <i class="fab fa-youtube"></i> */}
 
library.add(faHtml5, faCss3Alt, faJs, faCube, faReact, faLink, faYoutube)

let Icon = styled.svg`
    font-size: 3rem;
    margin: 0 2%;
`;

const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: 345,
    margin: "1%",
    // boxShadow: "3px 3px 8px 1px rgb(17, 17, 17)"
    boxShadow: "0.3em 0.3em 1em rgba(0,0,0,0.3)"
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

export default function Projects(props) {
  const {title, img, desc, letter, url, repo, video} = props;
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    
    <Card className={classes.card}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            {letter}
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            {/* <MoreVertIcon /> */}
          </IconButton>
        }
        title={title}
        // subheader="September 14, 2016"
      />
      <a href={url} target="_blank">
      <CardMedia
        className={classes.media}
        image={img}
        title={title}
      /></a>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          {desc}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="github repository link">
          {/* <FavoriteIcon /> */}
          {/* <Icon className="fab fa-html5" style={{color: "#df4b25"}}></Icon>
          <Icon className="fab fa-css3-alt" style={{color: "#1e5fa9"}}></Icon>
          <Icon className="fab fa-js" style={{color: "#e9d54d"}}></Icon> */}
          <a href={repo} target="_blank"><Icon className="fab fa-github-square"  style={{color: "#24292e"}}></Icon></a>
        </IconButton>
        <IconButton aria-label="link to deployed site">
          {/* <FavoriteIcon /> */}
          {/* <Icon className="fab fa-html5" style={{color: "#df4b25"}}></Icon>
          <Icon className="fab fa-css3-alt" style={{color: "#1e5fa9"}}></Icon>
          <Icon className="fab fa-js" style={{color: "#e9d54d"}}></Icon> */}
          <a href={url} target="_blank"><Icon className="fas fa-link"  style={{color: "#24292e"}}></Icon></a>
        </IconButton>
        {title === "Characteristiq" && <IconButton aria-label="link to deployed site">
          {/* <FavoriteIcon /> */}
          {/* <Icon className="fab fa-html5" style={{color: "#df4b25"}}></Icon>
          <Icon className="fab fa-css3-alt" style={{color: "#1e5fa9"}}></Icon>
          <Icon className="fab fa-js" style={{color: "#e9d54d"}}></Icon> */}
          <a href={video} target="_blank"><Icon className="fab fa-youtube"  style={{color: "#24292e"}}></Icon></a>
        </IconButton>}
        {/* <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton> */}
      </CardActions>
      {/* <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>Method:</Typography>
          <Typography paragraph>
            Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over medium-high
            heat. Add chicken, shrimp and chorizo, and cook, stirring occasionally until lightly
            browned, 6 to 8 minutes. Transfer shrimp to a large plate and set aside, leaving chicken
            and chorizo in the pan. Add pimentón, bay leaves, garlic, tomatoes, onion, salt and
            pepper, and cook, stirring often until thickened and fragrant, about 10 minutes. Add
            saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil.
          </Typography>
        </CardContent>
      </Collapse> */}
    </Card>
  );
}